import PropTypes from 'prop-types';
import { BsPencil } from 'react-icons/bs';

import { useWorkReportModals } from '../../../../../context/WorkReportModalsContext';
import './RejectButton.scss';
import { partesTrabajoDiarioItemsWorkReport } from '../../../../../utils/globalPropTypes';
import ComponentWithTooltip from '../../../../ComponentWithTooltip/ComponentWithTooltip';

/**
 * @typedef Props
 * @property {(action: import('../../../../WeeklyReportTable/reducer/optimisticUIReducer').OptimisticUIActions) => void} handleChangedActions
 */

/** @param {Props} */
const RejectButton = ({ dailyWorkReport, fetchData, handleChangedActions, selectedDate }) => {
  const { activeRejectModal } = useWorkReportModals();

  /** @param {{newQuantity: number, requireAccordance: boolean}} */
  const fetchDataWithDefaultParams = ({ newQuantity, requireAccordance }) => {
    fetchData();

    if (!requireAccordance) {
      handleChangedActions({ type: 'approver.fixed', payload: newQuantity });
      handleChangedActions({ type: 'inspector.revision' });

      return;
    }

    handleChangedActions({ type: 'approver.returned', payload: newQuantity });
  };

  const handleOnClick = () => {
    activeRejectModal(
      {
        ...dailyWorkReport,
        date: selectedDate,
        tienePuntosPrograma:
          dailyWorkReport?.tienePuntosPrograma || dailyWorkReport?.notificadaPorPuntoDePrograma,
        defaultValue: true
      },
      fetchDataWithDefaultParams
    );
  };

  return (
    <ComponentWithTooltip id="hidden-tooltip" tooltipText="Rechazar - Editar">
      <div className="d-flex reject-button-container container">
        <button
          aria-label="Rechazar"
          className="reject-button"
          onClick={handleOnClick}
          type="button"
        >
          <BsPencil size={18} />
        </button>
      </div>
    </ComponentWithTooltip>
  );
};

export default RejectButton;

RejectButton.propTypes = {
  dailyWorkReport: partesTrabajoDiarioItemsWorkReport.isRequired,
  selectedDate: PropTypes.string,
  handleChangedActions: PropTypes.func,
  fetchData: PropTypes.func
};

RejectButton.defaultProps = {
  fetchData: () => {},
  handleChangedActions: () => {},
  selectedDate: ''
};
